
import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { getCompanyInfo } from '@/api/approve'
import { backToBefore } from '@/utils/h5ToApp'
@Component({
  name: 'companyApproveFinish'
})
export default class companyApproveFinish extends Vue {
  @Getter companyId: string // 公司编号
  formData = {
    companyName: '', // 公司名称
    unifiedSocialCreditCode: '', // 统一社会信用代码
    legalPerson: '', // 法人姓名
    identityCard: '' // 身份证号码
  }
  created() {
    this.getCompanyInfo()
  }
  handleBack() {
    // this.$bridge.callHandler(
    //   'backApprovePage',
    //   {
    //     isUser: false
    //   },
    //   (res) => {
    //     console.log('返回企业信息页面', res)
    //   }
    // )
    if(this.$route.query.formPage === 'h5') {
      this.$router.push({
        path:'/shopMallOrder',
        query:{
          isHome:'home'
        }
      })
    }else {
      backToBefore()
    }
  }
  handleChange() {
    this.$router.push({
      name: 'CompanyInfoForm',
      query: { formPage: 'h5' }
    })
  }
  getCompanyInfo() {
    // console.log('this.companyId',this.companyId);
    // let companyId = '624e53ecd5e8c849151ffe2e'
    let companyId = this.companyId

    getCompanyInfo({ companyId }).then((res) => {
      console.log('res', res)
      this.formData.companyName = res.data.companyName
      this.formData.unifiedSocialCreditCode = res.data.unifiedSocialCreditCode
      this.formData.legalPerson = res.data.legalPerson
      this.formData.identityCard = res.data.idCard
    })
  }
}
